"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.XSushiOracleFactory = void 0;
var contracts_1 = require("@ethersproject/contracts");
var XSushiOracleFactory = /** @class */ (function (_super) {
    __extends(XSushiOracleFactory, _super);
    function XSushiOracleFactory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    XSushiOracleFactory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    XSushiOracleFactory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    XSushiOracleFactory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    XSushiOracleFactory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    XSushiOracleFactory.connect = function (address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    };
    return XSushiOracleFactory;
}(contracts_1.ContractFactory));
exports.XSushiOracleFactory = XSushiOracleFactory;
var _abi = [
    {
        inputs: [],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "CHAIN_LINK_DECIMALS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainLinkEthAggregator",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainLinkTokenAggregator",
        outputs: [
            {
                internalType: "contract IChainLinkAggregator",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainlinkEthScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "chainlinkTokenScalar",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "fetchCurrentPrice",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint256",
                        name: "value",
                        type: "uint256",
                    },
                ],
                internalType: "struct Decimal.D256",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "sushi",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "xsushi",
        outputs: [
            {
                internalType: "contract IERC20",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
var _bytecode = "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";
